import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const MenuSection = () => {
  const menuItems = [
    {
      title: "BREAKFAST",
      description:
        "At breakfast, we focus on unique menu items that we can offer quickly and consistently.",
      imgSrc: "breakfast.png", // Replace with actual image URL
    },
    {
      title: "LUNCH",
      description: "Our speciality is to serve quality food that is perfect for lunch.",
      imgSrc: "chicken.png", // Replace with actual image URL
    },
    {
      title: "DINNER",
      description:
        "Gather round the dinner table and feed the family with these cuisines that we’ve hand-picked and made for sharing.",
      imgSrc: "rice.png", // Replace with actual image URL
    },
  ];

  // Inline Styles
  const styles = {
    section: {
      padding: "50px 0",
      backgroundColor: "#000", // Black background for the section
      
    },
    col: {
      opacity: 0,
      transform: "translateY(20px)",
      animation: "fadeIn 0.6s ease forwards",
    },
    colAnimationDelay: (index) => ({
      animationDelay: `${index * 0.2}s`,
    }),
    img: {
      width: "100px",
      height: "100px",
      borderRadius: "50%",
      transition: "transform 0.3s ease, box-shadow 0.3s ease",
      boxShadow: "0 4px 6px rgba(255, 0, 0, 0.4)", // Red shadow for images
    },
    imgHover: {
      transform: "scale(1.1)",
      boxShadow: "0 8px 15px rgba(255, 0, 0, 0.7)", // Enhanced red shadow
    },
    title: {
      fontWeight: "bold",
      color: "#fff", // White text for titles
      marginTop: "10px",
    },
    description: {
      color: "#ccc", // Light gray text for descriptions
    },
    "@keyframes fadeIn": {
      from: {
        opacity: 0,
        transform: "translateY(20px)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0)",
      },
    },
  };

  return (
    <section style={styles.section}>
      <div className="container">
        <div className="row text-center">
          {menuItems.map((item, index) => (
            <div
              className="col-md-4 mb-4"
              key={index}
              style={{ ...styles.col, ...styles.colAnimationDelay(index) }}
            >
              <div className="d-flex flex-column align-items-center">
                <img
                  src={item.imgSrc}
                  alt={item.title}
                  style={styles.img}
                  className="menu-img"
                  onMouseOver={(e) => {
                    e.target.style.transform = styles.imgHover.transform;
                    e.target.style.boxShadow = styles.imgHover.boxShadow;
                  }}
                  onMouseOut={(e) => {
                    e.target.style.transform = styles.img.transform;
                    e.target.style.boxShadow = styles.img.boxShadow;
                  }}
                />
                <h3 style={styles.title}>{item.title}</h3>
                <p style={styles.description}>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MenuSection;
